import type { MantineSpacing } from '@mantine/core';
import { useState } from 'react';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { CalendarGuestChangesModal } from 'src/meetings/detail/components/CalendarGuestChangesModal';
import { MeetingBanner } from 'src/meetings/detail/components/MeetingBanner';
import type { CalendarEvent } from 'src/meetings/models';
import type { MeetingScope } from 'src/meetings/scope';

type Props = {
  event: CalendarEvent;
  scope?: MeetingScope;
  mt?: MantineSpacing;
  mb?: MantineSpacing;
};

export function CalendarGuestChangesBanner({ event, scope, mt, mb }: Props) {
  const { flagEnabledMeetingsRework } = useFlags();
  const [opened, setOpened] = useState(false);
  const visible = Boolean(flagEnabledMeetingsRework && event.attendeeDifferences?.length);

  // Hiding the banner unmounts the review without closing it, so a later guest change would reopen it unasked.
  if (opened && !visible) setOpened(false);

  if (!visible) {
    return null;
  }

  return (
    <>
      <MeetingBanner mt={mt} mb={mb} action={{ label: 'Review', onClick: () => setOpened(true) }}>
        {
          "The calendar's guest list changed, and the attendees were updated to match. Review the changes."
        }
      </MeetingBanner>
      <CalendarGuestChangesModal
        opened={opened}
        onClose={() => setOpened(false)}
        event={event}
        scope={scope}
      />
    </>
  );
}
